export const PAGE_HEADER_SIZE = 52;
export const PAGE_HEADER_SIZE_STRING = `${PAGE_HEADER_SIZE}px`;
